import logging from '../lib/logging';

export default () => next => (action) => {
  try {
    return next(action);
  } catch (err) {
    logging.error(err, {
      extra: {
        action,
      },
    });
    throw err;
  }
};
